// Eligibility for the default (empty-query) search list: a STABLE top-by-volume
// board of real, tradable TON tokens. Two filters on top of the server's
// volume_24h order:
//   1. ≥ $10k liquidity — drops thin/one-trade spikes so the board is browsable.
//   2. exclude USD stablecoins — they dominate by volume and aren't what a
//      browsing user is looking for.
//
// Stablecoins are matched by a CURATED MASTER-ADDRESS set, never a ticker/name
// heuristic: `lower(name) LIKE '%usd%'` false-positives real memecoins like
// "UranUSDog" (URDOG). Gold-pegged Tether (XAUt0) is intentionally NOT excluded
// — it is a commodity token, not a USD stablecoin.

import type { TokenSummary } from '../api/types'

export const DEFAULT_SEARCH_MIN_LIQUIDITY_USD = 10_000
export const TETHER_USDT_MASTER = 'EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs'

// Known TON USD-stablecoin jetton masters (Tether, bridged/wrapped USD, USDe,
// TrueUSD, 1RUSD). Verified against the local token DB by name + liquidity.
export const STABLECOIN_MASTERS: ReadonlySet<string> = new Set([
  TETHER_USDT_MASTER, // USD₮ — Tether USD
  'EQBynBO23ywHy_CgarY9NK9FTz0yDsG82PtcbSTQgGoXwiuA', // jUSDT — Bridged jUSDT
  'EQC_1YoM8RBixN95lz7odcF3Vrkc_N8Ne7gQi7Abtlet_Efi', // oUSDT — Orbit Bridge USDT
  'EQB-MPwrd1G6WKNkLz_VnV6WqBDd142KMQv-g1O-8QUA3728', // jUSDC — USD Coin
  'EQC61IQRl0_la95t27xhIpjxZt32vl1QQVF2UgTNuvD18W-4', // oUSDC — Orbit Bridge USDC
  'EQAIb6KmdfdDR7CN1GBqVJuP25iCnLKCvBlJ07Evuu2dzP5f', // USDe — Ethena USDe
  'EQDS7H9gaI3kn60vKDHTVYnipqWA34sHGlVW6-Jrl_dRCj1d', // TUSD — TrueUSD
  'EQBT2Ee4Lx5w9uI7oMly5upXNs3ABWL_Fwk1uiM74gZCGaYt', // 1RUSD — 1RUS DAO
])

export function isStablecoinToken(master: string): boolean {
  return STABLECOIN_MASTERS.has(master)
}

// isDefaultSearchToken gates a token into the default board: real liquidity and
// not a stablecoin. (TON-only + product-visible are already guaranteed upstream
// by /v1/tokens and isDiscoverProductToken.)
export function isDefaultSearchToken(t: TokenSummary): boolean {
  if (isStablecoinToken(t.jetton_master)) return false
  return typeof t.liquidity_usd === 'number' && t.liquidity_usd >= DEFAULT_SEARCH_MIN_LIQUIDITY_USD
}
